import { city } from "@/utils/cascaderArea";
import { Button, Col, Form, Input, message, Radio, Row, Select } from 'antd';
import axios from 'axios';
import React, { Component } from 'react';
import SliderValidate from '../SliderValidateCourse';
const {
  TextArea
} = Input;
const {
  Option
} = Select;

class LiveRoomForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: this.props.infoModalData,
      provinceAll: [],
      cityAll: [],
      countyAll: [],
      showSlider: false,
      btnDisable: false,
      slidStatus: 0,
      btnText: '发送验证码',
      x: 0,
      y: 0,
      currentDomain: window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://ts.dev.yunduoketang.cn'
    };
  }

  componentDidMount() {
    this.props.onRef(this);
    this.setState({
      provinceAll: city
    }, () => {
      this.initData();
    });
  }

  initData = () => {
    const {
      formData
    } = this.state;
    let obj = {};

    if (formData.province) {
      obj = this.state.provinceAll.find(item => item.label == formData.province);
    }

    this.setState({
      cityAll: obj && Object.keys(obj).length ? obj.children : []
    }, () => {
      // let tempFormData = formData;
      // if(formData.county == '') {
      //   tempFormData.county = formData.city
      //   tempFormData.city = formData.province
      // }
      this.setState({
        countyAll: formData.city && this.state.cityAll.find(item => item.label == formData.city) ? this.state.cityAll.find(item => item.label == formData.city).children : [] // formData: tempFormData

      });
    });
  };
  checkData = () => {
    let result;
    this.props.form.validateFieldsAndScroll((err, value) => result = err);
    return result;
  };
  onChangeSex = (e, key) => {
    let formData = Object.assign({}, this.state.formData, {
      sex: e.target.checked
    });
    this.setState({
      formData
    });
  };
  onEduChange = value => {
    let formData = Object.assign({}, this.state.formData, {
      educationCode: value
    });
    this.setState({
      formData
    });
  };
  onIdenChange = value => {
    let formData = Object.assign({}, this.state.formData, {
      identityTypeCode: value
    });
    this.setState({
      formData
    });
  };
  onIdenIdChange = e => {
    let formData = Object.assign({}, this.state.formData, {
      identityId: e.target.value
    });
    this.setState({
      formData
    });
  };
  hanldeSmsCode = e => {
    let formData = Object.assign({}, this.state.formData, {
      smsCode: e.target.value
    });
    this.setState({
      formData
    });
  };
  hanldeProvince = value => {
    let formData = Object.assign({}, this.state.formData, {
      province: value,
      city: undefined,
      county: undefined
    });
    this.setState({
      formData,
      countyAll: [],
      city: undefined,
      county: undefined,
      cityAll: this.state.provinceAll.find(item => item.label == value).children
    });
  };
  hanldeCity = value => {
    let formData = Object.assign({}, this.state.formData, {
      city: value,
      county: undefined
    });
    this.setState({
      formData,
      countyAll: this.state.cityAll.find(item => item.label == value) ? this.state.cityAll.find(item => item.label == value).children : []
    });
  };
  hanldeCounty = value => {
    let formData = Object.assign({}, this.state.formData, {
      county: value
    });
    this.setState({
      formData
    });
  };
  hanldeAddress = e => {
    let formData = Object.assign({}, this.state.formData, {
      addressDetail: e.target.value
    });
    this.setState({
      formData
    });
  };
  showSliderValid = value => {
    this.setState({
      showSlider: value
    });
  };
  getSliderPosition = position => {
    this.setState({
      slidStatus: position.result,
      x: position.x,
      y: position.y,
      btnDisable: position.result == 1 ? true : false,
      module: 'classType'
    });
  };
  getCode = () => {
    // 发送验证码
    let mobile = this.props.form.getFieldValue('mobile');
    axios({
      url: `${this.state.currentDomain}/register/sendSMS/classType/${mobile}/${this.sliderCom.state.sliderX}_${this.sliderCom.state.sliderY}?codeType=CHANGE_PHONE`,
      method: 'post'
    }).then(res => {
      console.log(res);

      if (res.data) {
        let data = res.data;
        let index = data.indexOf('error');

        if (index > 0) {
          let arr = data.split(':');
          message.error(arr[3] || '发送失败');
          return;
        }

        let seconds = 60;
        let timer = setInterval(() => {
          if (seconds == 0) {
            clearInterval(timer);
            this.setState({
              btnText: `重新获取验证码`,
              btnDisable: true
            });
            return false;
          }

          --seconds;
          this.setState({
            btnText: `(${seconds}s)后重试`,
            btnDisable: false
          });
        }, 1000);
      } else {
        message.error('短信验证码发送异常');
      }
    });
  };
  /**
   *[username]学员名称
    [cardtype]证件类型
    [StudentIDcardnumber]学员证件号码
    [Studentcellphonenumber]学员电话号码
    [sex]性别
    [education]学历
    [address]邮寄地址
  */

  render() {
    const {
      state,
      props
    } = this;
    const {
      username,
      cardtype,
      StudentIDcardnumber,
      Studentcellphonenumber,
      sex,
      education,
      address
    } = props.deficiencyInfo || {};
    const layout = {
      labelCol: {
        span: 4
      },
      wrapperCol: {
        span: 18
      }
    };
    const {
      getFieldDecorator
    } = this.props.form;

    const rulesIdentityTypeCode = (rule, value, callback) => {
      const {
        identityId,
        identityTypeCode
      } = this.state.formData;

      if (!value) {
        callback('请输入证件号');
      } else {
        if (identityTypeCode == 'ID_IDCARD') {
          var bo = /^(\d{6})(18|19|20)?(\d{2})([01]\d)([0123]\d)(\d{3})(\d|X)?$/.test(value);
          var year = value.substr(6, 4);
          var month = value.substr(10, 2);
          var day = value.substr(12, 2);

          if (bo == false || month > 12 || day > 31) {
            callback('请输入正确的身份证号码');
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };

    const rulesAddress = (rule, value, callback) => {
      const {
        city,
        county
      } = this.state.formData;
      console.log(value, city, county);

      if (!value) {
        callback('请选择省');
      } else if (!city) {
        callback('请选择市');
      } else if (!county) {
        callback('请选择区');
      } else {
        callback();
      }
    };

    return <Form data-inspector-line="234" data-inspector-column="6" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" {...layout} name="live_room_form">
        <Row data-inspector-line="235" data-inspector-column="8" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" gutter={24}>
          {username && <Col data-inspector-line="236" data-inspector-column="23" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" span={24}>
            <Form.Item data-inspector-line="237" data-inspector-column="12" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" label="姓名">
              {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: '请输入姓名'
              }],
              initialValue: state.formData.name
            })(<Input data-inspector-line="244" data-inspector-column="19" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" placeholder="请输入姓名" style={{
              width: '380px'
            }} />)}
            </Form.Item>
          </Col> || null}
          {cardtype && <Col data-inspector-line="249" data-inspector-column="23" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" span={24}>
            <Form.Item data-inspector-line="250" data-inspector-column="12" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" label="证件类型">
              {getFieldDecorator('identityTypeCode', {
              rules: [{
                required: true,
                message: '请输入证件类型'
              }],
              initialValue: state.formData.identityTypeCode
            })(<Select data-inspector-line="257" data-inspector-column="19" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" placeholder="请选择证件类型" onChange={this.onIdenChange} allowClear style={{
              width: '380px'
            }}>
                    <Option data-inspector-line="262" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="ID_IDCARD">身份证</Option>
                    <Option data-inspector-line="263" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="ID_PASSPORT">护照</Option>
                    <Option data-inspector-line="264" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="ID_HMP">港澳通行证</Option>
                    <Option data-inspector-line="265" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="ID_TCP">台胞证</Option>
                    <Option data-inspector-line="266" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="ID_OFFICERS">军官证</Option>
                    <Option data-inspector-line="267" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="ID_SERGEANTS">士官证</Option>
                    <Option data-inspector-line="268" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="ID_UNCONFM_ID">未确定证件</Option>
                  </Select>)}
            </Form.Item>
          </Col> || null}
          {StudentIDcardnumber && <Col data-inspector-line="272" data-inspector-column="34" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" span={24}>
            <Form.Item data-inspector-line="273" data-inspector-column="12" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" label="证件号">
              {getFieldDecorator('identityId', {
              rules: [{
                required: true,
                validator: (rule, value, callback) => rulesIdentityTypeCode(rule, value, callback)
              }],
              initialValue: state.formData.identityId
            })(<Input data-inspector-line="280" data-inspector-column="19" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" placeholder="请输入证件号" onChange={this.onIdenIdChange} style={{
              width: '380px'
            }} />)}
            </Form.Item>
          </Col> || null}
          {Studentcellphonenumber && <Col data-inspector-line="286" data-inspector-column="37" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" span={24}>
            <Form.Item data-inspector-line="287" data-inspector-column="12" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" label="手机号">
              {getFieldDecorator('mobile', {
              rules: [{
                required: true,
                message: '请输入手机号'
              }, {
                validateTrigger: 'onBlur',
                pattern: /^1\d{10}$/,
                message: '手机号格式不正确'
              }],
              initialValue: state.formData.mobile
            })(<Input data-inspector-line="295" data-inspector-column="19" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" placeholder="请输入手机号" style={{
              width: '380px'
            }} />)}
            </Form.Item>
          </Col> || null}
          {sex && <Col data-inspector-line="300" data-inspector-column="18" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" span={24}>
            <Form.Item data-inspector-line="301" data-inspector-column="12" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" label="性别">
              {getFieldDecorator('sex', {
              rules: [{
                required: true,
                message: '请输入性别'
              }],
              initialValue: state.formData.sex
            })(<Radio.Group data-inspector-line="306" data-inspector-column="19" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" onChange={e => this.onChangeSex(e, 'sex')} style={{
              width: '380px'
            }}>
                    <Radio data-inspector-line="309" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value='MALE'>男</Radio>
                    <Radio data-inspector-line="310" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value='FEMALE'>女</Radio>
                  </Radio.Group>)}
            </Form.Item>
          </Col> || null}
          {education && <Col data-inspector-line="314" data-inspector-column="24" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" span={24}>
            <Form.Item data-inspector-line="315" data-inspector-column="12" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" required label="学历">
              {getFieldDecorator('educationCode', {
              rules: [{
                required: true,
                message: '请选择学历'
              }],
              initialValue: state.formData.educationCode
            })(<Select data-inspector-line="323" data-inspector-column="19" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" placeholder="请选择学历" onChange={this.onEduChange} allowClear style={{
              width: '380px'
            }}>
                    <Option data-inspector-line="328" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="primary_school">小学</Option>
                    <Option data-inspector-line="329" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="juniorHigh_school">初中</Option>
                    <Option data-inspector-line="330" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="seniorHigh_school">高中</Option>
                    <Option data-inspector-line="331" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="UNDER_JUNIOR">大专以下</Option>
                    <Option data-inspector-line="332" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="JUNIOR">大专</Option>
                    <Option data-inspector-line="333" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="BECHELOR">本科</Option>
                    <Option data-inspector-line="334" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="POSTGRADUATE">研究生</Option>
                    <Option data-inspector-line="335" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" value="DOCTOR">博士生及以上</Option>
                  </Select>)}
            </Form.Item>
          </Col> || null}
          {address && <React.Fragment><Col data-inspector-line="339" data-inspector-column="38" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" span={24}>
            <Col data-inspector-line="340" data-inspector-column="12" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" span={8}>
              <Form.Item data-inspector-line="341" data-inspector-column="14" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" labelCol={{
                span: 12
              }} wrapperCol={{
                span: 12
              }} label="地址">
                  {getFieldDecorator('province', {
                  rules: [{
                    required: true,
                    message: "请选择省"
                  }],
                  initialValue: state.formData.province
                })(<Select data-inspector-line="348" data-inspector-column="19" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" style={{
                  width: '130px'
                }} onChange={this.hanldeProvince} placeholder="请选择省">
                    {state.provinceAll.map(item => <Option data-inspector-line="353" data-inspector-column="52" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" key={item.value} value={item.label}>{item.label}</Option>)}
                </Select>)}
                </Form.Item>
            </Col>
            {state.cityAll && state.cityAll.length > 0 && <Col data-inspector-line="358" data-inspector-column="60" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" span={6}>
              <Form.Item data-inspector-line="359" data-inspector-column="14" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" colon={false} wrapperCol={{
                span: 21,
                offset: 2
              }}>
                  {getFieldDecorator('city', {
                  rules: [{
                    required: true,
                    message: "请选择市"
                  }],
                  initialValue: state.formData.city
                })(<Select data-inspector-line="365" data-inspector-column="19" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" style={{
                  width: '130px'
                }} placeholder="请选择市" onChange={this.hanldeCity}>
                    {state.cityAll.map(item => <Option data-inspector-line="370" data-inspector-column="48" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" key={item.value} value={item.label}>{item.label}</Option>)}
                  </Select>)}
                </Form.Item>
             </Col> || null}
            {state.countyAll && state.countyAll.length > 0 && <Col data-inspector-line="375" data-inspector-column="64" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" span={6}>
              <Form.Item data-inspector-line="376" data-inspector-column="14" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" colon={false} wrapperCol={{
                span: 21,
                offset: 2
              }}>
                  {getFieldDecorator('county', {
                  rules: [{
                    required: true,
                    message: "请选择区"
                  }],
                  initialValue: state.formData.county
                })(<Select data-inspector-line="382" data-inspector-column="19" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" style={{
                  width: '130px'
                }} placeholder="请选择区" onChange={this.hanldeCounty}>
                    {state.countyAll.map(item => <Option data-inspector-line="387" data-inspector-column="50" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" key={item.value} value={item.label}>{item.label}</Option>)}
                </Select>)}
                </Form.Item>
            </Col> || null}
          </Col>
          <Col data-inspector-line="393" data-inspector-column="10" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" span={24}>
            <Form.Item data-inspector-line="394" data-inspector-column="12" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" colon={false} wrapperCol={{
              span: 20,
              offset: 4
            }}>
              {getFieldDecorator('addressDetail', {
                initialValue: state.formData.addressDetail
              })(<TextArea data-inspector-line="397" data-inspector-column="96" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" onChange={this.hanldeAddress} placeholder="请输入详细地址" style={{
                width: '380px'
              }} />)}
            </Form.Item>
          </Col></React.Fragment> || null}
          {this.state.showSlider && Studentcellphonenumber && <React.Fragment><Col data-inspector-line="404" data-inspector-column="80" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" span={24}>
              <Form.Item data-inspector-line="405" data-inspector-column="14" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" colon={false} wrapperCol={{
              span: 21,
              offset: 3
            }}>
                <SliderValidate data-inspector-line="408" data-inspector-column="16" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" onSlider={el => this.sliderCom = el} callback={this.getSliderPosition} />
              </Form.Item>
            </Col>
            <Col data-inspector-line="411" data-inspector-column="12" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" span={24}>
              <Form.Item data-inspector-line="412" data-inspector-column="14" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" colon={false} wrapperCol={{
              span: 21,
              offset: 3
            }}>
                {getFieldDecorator('smsCode', {
                rules: [{
                  required: true,
                  message: "请填写短信验证码"
                }],
                initialValue: state.formData.smsCode
              })(<React.Fragment>
                    <Input data-inspector-line="419" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" style={{
                  width: '325px',
                  marginRight: '20px'
                }} placeholder="短信验证码" onChange={this.hanldeSmsCode} />
                    <Button data-inspector-line="422" data-inspector-column="20" data-inspector-relative-path="src\\components\\LiveRoom\\form.jsx" className="change-font-white-background-shallow" disabled={this.state.slidStatus == 1 && this.state.btnDisable ? false : true} type="primary" onClick={this.getCode}>{this.state.btnText}</Button>
                  </React.Fragment>)}
              </Form.Item>
            </Col>
          </React.Fragment> || null}
        </Row>
      </Form>;
  }

}

export default Form.create()(LiveRoomForm);